import { RootState } from '@/store';
import { CommissionState, COMMISSION_SLICE_NAME } from './models';

export const commissionSelector = (state: RootState): CommissionState => state[COMMISSION_SLICE_NAME];

export const selectHistoryQuery = (state: RootState) => state[COMMISSION_SLICE_NAME].historyQuery;
